import { GET_RECIPES } from "../actions";
import { FILTER_BY_DIET } from "../actions";
import { ORDER_BY_NAME } from "../actions";
import { GET_NAME_RECIPES } from "../actions";
import { ORDER_BY_HEALTHSCORE } from "../actions";
import { RECIPE_DETAIL } from "../actions";
import { POST_RECIPE } from "../actions";
import { GET_DIETS} from "../actions";
import { ORDER_BY_CREATEDORAPI } from "../actions";
import {LIMPIAR_FILTRO} from "../actions";


//Primero el estado inicial
const initialState = {
    recipes: [],
    copia: [],
    recipesDetail:[],
    recipesVacioDetail:[],
    diet:[]
}

function rootReducer (state = initialState, action) {
    switch(action.type){
            case GET_RECIPES:
                return {
                    ...state,
                    recipes: action.payload,
                    copia: action.payload,
                    recipesDetail: action.payload
                }
            case GET_NAME_RECIPES:
                return {
                    ...state,
                    recipes:[...action.payload]
                }
        
            case FILTER_BY_DIET:

                const allDiets = state.copia

                const dietsFiltered = action.payload === 'all'? allDiets : allDiets.filter(e=> e.diets.includes(action.payload)) 
                return{
                    ...state,
                    recipes: [...dietsFiltered]
                }
        
            case ORDER_BY_NAME:

                const allRecipes = state.recipes
                let sortedArr = action.payload === 'asc' ? allRecipes.sort(function(a,b){
                    if(a.title> b.title){
                        return 1; //1 Sería el b, ya que es el indice lo que retorbna
                    }
                    if(b.title > a.title){
                        return -1
                    }
                    return 0; // Esto lo devuelve igual, si son iguales no hace cambios y los devuelve como venían
                }) : allRecipes.sort(function(a,b){
                    if(a.title> b.title){
                        return -1; 
                    }
                    if(b.title > a.title){
                        return 1
                    }
                    return 0; 
                })
                return{
                ...state,
                recipes: [...sortedArr]
            }
            case ORDER_BY_HEALTHSCORE:
                const allHealthScores=state.recipes
                let sortedHealth= action.payload === 'score asc' ? allHealthScores.sort(function(a,b){
                    if(a.healthScore > b.healthScore){
                        return 1
                    }
                    if(b.healthScore > a.healthScore){
                        return -1
                    }
                    return 0
                }): allHealthScores.sort(function(a,b){
                    if(a.healthScore > b.healthScore){
                        return -1
                    }
                    if(b.healthScore > a.healthScore){
                        return 1
                    }
                    return 0 
                })
                return {
                    ...state,
                    recipes: [...sortedHealth]
                }
            case ORDER_BY_CREATEDORAPI:
                console.log('Entre al Reducer de CreatedOrApi')
                const arrayTotal = state.recipes;
                let createByMe= arrayTotal.filter(e => e.id.length > 20)
                let createByApi = arrayTotal.filter( e=> e.id < 1000000)
                console.log(createByApi)
                let array;
                if(action.payload === 'all'){
                    array = arrayTotal
                }
                if(action.payload === "api"){
                    console.log('Ahora entre al if de API')
                    array = createByApi
                    
                }
                if( action.payload === "create"){
                    array = createByMe
                }
                return{
                    ...state,
                    recipes: array
                }

            case RECIPE_DETAIL:
                const copia = state.copia
                return{
                    ...state,
                    recipesDetail:action.payload
                }
            case POST_RECIPE:
                console.log('POST RECIPE',action.payload)
                const resp =  [...state.recipes, action.payload]
                return { ...state,
                        recipes:resp,
                        copia: resp
                };
            case GET_DIETS:
                return { 
                    ...state,
                    diet: action.payload 
                }
            case LIMPIAR_FILTRO:
                const vacio = state.recipesVacioDetail
                return{
                    ...state,
                    recipesDetail: vacio
                }
        default: return state;
    }

}

export default rootReducer;